import { useState } from "react";
import { ToastQueue } from "@repo/design-system";

/**
 * Wraps a streaming-download function (filters or selected-IDs shaped, both
 * end in an `onProgress` callback) with isDownloading/progress state, a
 * failure toast, and guarding against a second concurrent download.
 */
export function useDownloadWithProgress<TArg>(
  downloadFn: (
    arg: TArg,
    onProgress: (percent: number | null) => void,
  ) => Promise<void>,
) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [progress, setProgress] = useState<number | null>(null);

  const trigger = async (arg: TArg) => {
    if (isDownloading) return;
    setIsDownloading(true);
    setProgress(null);
    try {
      await downloadFn(arg, (percent) => setProgress(percent));
    } catch {
      ToastQueue.danger("Download failed. Please try again.");
    } finally {
      setIsDownloading(false);
      setProgress(null);
    }
  };

  return { isDownloading, progress, trigger };
}
